<ng-select
	#ngSelect
	[items]="liveSearchItems$ | async"
	[labelForId]="attributeId"
	appendTo="body"
	[multiple]="multiple"
	[closeOnSelect]="closeOnSelect"
	[searchable]="searchable"
	[typeahead]="autocompleteItems$"
	[minTermLength]="minTermLength"
	[clearSearchOnAdd]="true"
	[clearable]="clearable"
	[loading]="dataLoading"
	[addTag]="addTag ? addTagFc : false"
	bindLabel="label"
	bindValue="value"
	[(ngModel)]="value"
	[disabled]="controlField ? controlField.disabled : false"
	(change)="onChange($event)"
	(ngModelChange)="handleNgModelChange($event)"
	(clear)="onClear()"
	[notFoundText]="'NgSelect.NotFoundText' | translate"
	[typeToSearchText]="'NgSelect.TypeToSearchText' | translate"
	addTagText=""
	[loadingText]="'NgSelect.LoadingText' | translate"
	[clearAllText]="'NgSelect.ClearAllText' | translate"
	[placeholder]="'Forms.Placeholder.SearchAdd' | translate"
>

	<ng-template #highlight ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
		<ng-container [ngSwitch]="templateType">
			<ng-container *ngSwitchCase="autocompleteTemplateType.Checkbox">
				<!-- <input id="item-{{ index }}" type="checkbox" [ngModel]="item.selected" /> -->
				{{ item.label }}
			</ng-container>
			<ng-container *ngSwitchCase="autocompleteTemplateType.Custom">
				<ng-template [ngTemplateOutlet]="customTemplate" [ngTemplateOutletContext]="{ item: item }"></ng-template>
			</ng-container>
			<ng-container *ngSwitchDefault>
				<div [ngOptionHighlight]="search">
					{{ item.label }}
				</div>
			</ng-container>
		</ng-container>
	</ng-template>
</ng-select>
